import { useState, useEffect } from 'react';

// Tipo para a opção de visualização de tabs
export type TabViewMode = 'categorized' | 'unified';

// Array das opções válidas para checagem de tipo
const validModes: TabViewMode[] = ['categorized', 'unified'];

// Função auxiliar para verificar se um valor é uma TabViewMode válida
function isValidTabViewMode(value: string): value is TabViewMode {
  return validModes.includes(value as TabViewMode);
}

/**
 * Hook para gerenciar a preferência de visualização entre tabs
 * Armazena a escolha do usuário no localStorage para persistência
 */
export function useTabViewPreference() {
  // Recupera a preferência do localStorage ou usa 'categorized' como padrão
  const [activeTab, setActiveTabState] = useState<TabViewMode>(() => {
    const savedPreference = localStorage.getItem('voah_tab_view_preference');
    const validPreference = isValidTabViewMode(savedPreference || '') 
      ? savedPreference as TabViewMode 
      : 'categorized';
    
    console.log('TabView: Preferência recuperada do localStorage:', savedPreference, 'uso:', validPreference);
    return validPreference;
  });

  // Função para definir a tab ativa com validação de tipo
  const setActiveTab = (value: string) => {
    console.log('TabView: Alterando preferência para:', value);
    if (isValidTabViewMode(value)) {
      setActiveTabState(value);
    } else {
      console.warn('TabView: Valor inválido ignorado:', value);
    }
  };

  // Atualiza o localStorage quando a preferência muda
  useEffect(() => {
    console.log('TabView: Salvando preferência no localStorage:', activeTab);
    localStorage.setItem('voah_tab_view_preference', activeTab);
  }, [activeTab]);

  return { activeTab, setActiveTab };
} 